import { coversDay, fmtDayShort, toISODate, weekDays } from '@/shared/lib'
import type { Block, Column } from '../model/types'

interface ColumnOwner {
  id: string
  title: string
  subtitle: string | null
}

/** Вид «День»: колонка = сотрудник. Порядок задаёт вызывающий (бэкенд сортирует по имени). */
export function employeeColumns(day: Date, owners: ColumnOwner[]): Column[] {
  return owners.map((owner) => ({
    key: `emp:${owner.id}`,
    title: owner.title,
    subtitle: owner.subtitle,
    day,
    ownerId: owner.id,
  }))
}

/** Вид «Неделя»: колонка = день. Владельца нет — в колонку падает всё, что показано. */
export function dayColumns(anchor: Date): Column[] {
  return weekDays(anchor).map((day) => ({
    key: `day:${toISODate(day)}`,
    title: fmtDayShort(day),
    subtitle: null,
    day,
    ownerId: null,
  }))
}

/** Принадлежит ли блок колонке: день пересечён и владелец совпал. */
export function belongsTo(block: Block, column: Column): boolean {
  if (!coversDay(block.slot, column.day)) return false
  return column.ownerId === null || block.ownerIds.includes(column.ownerId)
}

/**
 * Группировка одним проходом по колонкам. Донорский подход «фильтровать весь
 * массив на каждую колонку» на десяти колонках стоит десяти проходов — здесь
 * один проход по блокам на колонку сразу раскладывает их по вёдрам.
 */
export function groupByColumn(blocks: Block[], columns: Column[]): Map<string, Block[]> {
  const buckets = new Map<string, Block[]>(columns.map((c) => [c.key, []]))
  for (const column of columns) {
    const bucket = buckets.get(column.key)
    if (!bucket) continue
    for (const block of blocks) {
      if (belongsTo(block, column)) bucket.push(block)
    }
  }
  return buckets
}
